
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, empty, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { environment } from '../../../environments/environment';
import { Organization } from '../../model/organization';
import { Webhook } from '../../model/webhook';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {

  asgAdminUrl: string;
  getOrgDetail: any;

  constructor(private http: HttpClient) { }

  getOrganizationsList(): Observable<Organization[]> {
    let url = environment.asgAdminUrl + "/asg/admin/organizations";
    return this.http.get<Organization[]>(url).pipe(
      map((data: any) => {


        return data;
      }),
      catchError((error) => {
        return error;
      })
    );
  }
  
  getAllMsgEndpoints(orgId: string) {
    let url = environment.asgAdminUrl + "/v1/organizations/" + orgId + "/msgendpoints";
    return this.http
      .get(url)
      .toPromise()
      .then((response: any) => response as any)
      .catch((error) => {
        return throwError(error.error);
      });
  }
  getOrganization(orgId: string): Observable<Organization> {
    let url = environment.asgAdminUrl + '/asg/admin/organizations/' + orgId;
    return this.http.get<Organization>(url).pipe(
      map((data: any) => {
        data.validFrom = new Date(data.validFrom);
        data.validTo = new Date(data.validTo);
        return data;
      }),
      catchError((error) => {
        return error;
      })
    );
  }

  saveOrg(org: Organization): Observable<Organization> {
    let url = environment.asgAdminUrl + "/asg/admin/organizations";

    return this.http.post(url, org).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error.error);
      })
    );
  }
  createMesEndpoint(data, orgId) {
    let url = environment.asgAdminUrl + "/v1/organizations/" + orgId + "/msgendpoints";
    return this.http
      .post(url, data)
      .toPromise()
      .then((response: any) => response as any)
      .catch((error) => {
        return throwError(error.error);
    });
  }

  updateMesEndpoint(data, orgId, msgKey) {
    let url = environment.asgAdminUrl + `/v1/organizations/${orgId}/msgendpoints/${msgKey}`;
    // let url = v1/organizations/3031/msgendpoints/b11e48b5-07ae-4da3-bf92-daa590066584;
    return this.http.put<Organization>(url, data).pipe(
      map((data: any) => {
        data.validFrom = new Date(data.validFrom);
        data.validTo = new Date(data.validTo);
        return data;
      }),
      catchError((error) => {

        return throwError(error.error);
      })
    );
  }


  updateOrg(orgId, org): Observable<Organization> {
    let url = environment.asgAdminUrl + `/asg/admin/organizations/${orgId}`;

    org.orgId = orgId;
    return this.http.put<Organization>(url, org).pipe(
      map((data: any) => {
        data.validFrom = new Date(data.validFrom);
        data.validTo = new Date(data.validTo);
        return data;
      }),
      catchError((error) => {

        return throwError(error.error);
      })
    );
  }

  public getOrgConfigData(orgId) {
    let url = environment.asgAdminUrl + `/v1/organizations/${orgId}/configurations/_search?systemName=TRANSCRIBER`;
    return this.http
      .get(url)
      .toPromise()
      .then((response: any) => response as any)
      .catch((error) => {

        return throwError(error.error);
      });
  }
  public getOrgBasicConfigData(orgId) {
    let url = environment.asgAdminUrl + `/v1/organizations/${orgId}/configurations/basic?systemName=TRANSCRIBER`;
    return this.http
      .get(url)
      .toPromise()
      .then((response: any) => response as any)
      .catch((error) => {

        return throwError(error.error);
      });
  }

  public saveOrgConfigData(orgId, formData) {
    let url =
      environment.asgAdminUrl + "/v1/organizations/" + orgId + "/configurations";
    return this.http
      .post(url, formData)
      .toPromise()
      .then((response: any) => response as any)
      .catch((error) => {

        return throwError(error.error);
      });
  }

  public clearCache(orgId): Observable<any> {
    return this.http.get(
      environment.iformWebformAPIUrl + "/asg/aws/population/clearCache?orgId=" + orgId,
      { responseType: "text" }
    );
  }

  public updateOrgConfigData(orgId, configKey, formData) {
    let url =
      environment.asgAdminUrl +
      "/v1/organizations/" +
      orgId +
      "/configurations/" +
      configKey;
    return this.http
      .put(url, formData)
      .toPromise()
      .then((response: any) => response as any)
      .catch((error) => {

        return throwError(error.error);
      });
  }

  public deleteOrg(id, data) {
    return this.http
      .put<any>(
        environment.asgAdminUrl + "/asg/admin/organizations/" + id + "/deactivate",
        data
      )
      .pipe(
        map((dataRes) => {
          return dataRes;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public deleteAssociatedUser(reqData) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.delete(environment.asgAdminUrl + `/asg/admin/Organization/${reqData.org_id}/associateUsers/${reqData.user_id}`, httpOptions);
  }

  public getWebHookData(orgId): Observable<Webhook[]> {
    let url = environment.asgAdminUrl + `/v1/organizations/${orgId}/endpoints`;
    return this.http.get<Webhook[]>(url)
      .pipe();
  }

  public createWebhook(orgId, webhookBbj): Observable<Webhook> {
    let url = environment.asgAdminUrl + `/v1/organizations/${orgId}/endpoints`;

    return this.http.post<Webhook>(url, webhookBbj).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error.error);
      })
    );
  }

  public updateWebhook(orgId: string, webhookObj: Webhook): Observable<Webhook> {
    const organizationEndpointKey = webhookObj.organizationEndpointKey;
    let url = environment.asgAdminUrl + `/v1/organizations/${orgId}/endpoints/${organizationEndpointKey}`;

    return this.http.put<Webhook>(url, webhookObj).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error.error);
      })
    );
  }

  public deleteMesgEndpoint(orgId: string, organizationMsgEndpointKey: string){
    let url = environment.asgAdminUrl + `/v1/organizations/${orgId}/msgendpoints/${organizationMsgEndpointKey}`;
    return this.http.delete(url).toPromise();
  }
  public deleteWebhook(orgId: string, organizationEndpointKey: string){

    let url = environment.asgAdminUrl + `/v1/organizations/${orgId}/endpoints/${organizationEndpointKey}`;
    return this.http.delete(url).toPromise();

  }
  getAnalyticsCount(payload) {
    let url = environment.mappingToolAPIUrl+ `/v1/analytics/count`;
    return this.http.post(url, payload);
  }
  getWebhookData(payload) {
    let url = environment.mappingToolAPIUrl+ `/v1/dashboards/webhooks/received`;
    return this.http.post(url, payload);
  }
  getWebhookDataDetails(payload) {
    let url = environment.mappingToolAPIUrl+ `/v1/audits/WEBHOOKS_EVENT`;
    return this.http.post(url, payload);
  }
  getAnalyticsTop5Records(payload) {
    let url = environment.mappingToolAPIUrl+ `/v1/analytics/asgAnalyticsDownloadRequest`;
    return this.http.post(url, payload);
  }
  checkAnalyticsRequestStatus(requestId) {
    let url = environment.mappingToolAPIUrl +`/v1/analytics/reports/download/${requestId}/status`;
    return this.http.get(url, { responseType: "text" });
  }
  requestAnalyticsReport(payload) {
    let url = environment.mappingToolAPIUrl + `/v1/analytics/reports/download`;
    return this.http.post(url, payload, { responseType: "text" });
  }
  downloadAnalyticsFile(requestId) {
    let url = environment.mappingToolAPIUrl + `/v1/analytics/download/${requestId}`;
    return this.http.get(url, { responseType: "text" });
  }
}